import { Component, ComponentListResponseMessageSchema, ComponentSchema, ComponentsSchema, Message, CollectionRegistry } from "../types";
import { logger } from "../utils/logger";


export async function handleComponentListResponse(
    data: any,
    storeComponents:(components: Component[])=>void,
    collections?: CollectionRegistry
  ): Promise<void> {
    try {
      const componentListResponse = ComponentListResponseMessageSchema.parse(data);
      const { payload } = componentListResponse;

      const componentsList = payload.components;

      if(!componentsList){
            logger.error('Components list not found in the response');
          return;
      }

      const components = ComponentsSchema.parse(componentsList);
      storeComponents(components);

      // Embed display components for semantic search if collection is available
      const embedHandler = collections?.['components']?.['embed'];
      if (embedHandler) {
        try {
          logger.info('Embedding display components for semantic search...');
          const result = await embedHandler({ components });
          if (result.success) {
            logger.info(`Successfully embedded ${result.count} display components`);
          } else {
            logger.warn('Failed to embed components:', result.error);
          }
        } catch (embedError) {
          logger.warn('Failed to embed components:', embedError);
        }
      }

      return;
    } catch (error) {
      logger.error('Failed to handle user prompt request:', error);
    }
  }


